import * as React from 'react';
import { Button, Card } from '@salesforce/design-system-react';
import clickFlows from '../data/click-flows';
import { ScreenFlow } from 'lib/types';

class Listing extends React.Component<{}> {
	componentWillMount () {
		document.title = 'Customer 360 Demo Listing';
	}

	openDemo (path: string) {
		window.location.pathname = path;
	}

	renderListing (screenFlow: ScreenFlow, path: string) {
		const badgeStyle = {display: 'inline-block', marginLeft: '8px'};

		return (
			<Card 
				heading={
					<span>
						<a href={path} target="_blank">{screenFlow.name}</a>
						<span className="slds-badge" style={badgeStyle}>{screenFlow.brandName}</span>
					</span>
				}
				headerActions={<Button onClick={() => this.openDemo(path)} label="View Demo" />}
			>
				<p className="slds-m-horizontal_medium">{screenFlow.description}</p>
			</Card>
		);
	}

	render () {

		return (
			<div className="demo-listing slds-p-around_large">
				<div className="slds-global-header__logo slds-m-bottom_large" />
				<div className="slds-grid slds-grid--vertical">
					{Object.keys(clickFlows).map((path, idx) => {
						const flow = clickFlows[path];
						const card = this.renderListing(flow, `/demo/${path}`);
					
						return card;
					})}
				</div>
			</div>
		);
	}
}
export default Listing;


// WEBPACK FOOTER //
// ./src/App/Listing.tsx